import { createContext, useContext, useState } from 'react';

const SearchContext = createContext({ isOpen: false, open: () => {}, close: () => {} });

export function SearchProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <SearchContext.Provider value={{ isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false) }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  return useContext(SearchContext);
}
